<template>
  <div class="report-component">
    <div class="row">
      <div class="col-lg-4">
        <div class="box">
          <div class="box-header with-border">
            <h1 class="box-title">Search</h1>
          </div>
          <div class="box-body">
            Search for a car by it's registration, number or from an active reservation in the form below.<br/><br/>
            <form class="form-horizontal" v-on:submit.prevent="search"
              v-el:form="">
              <div class="form-group">
                <label class="col-sm-4 control-label">Car Registration:</label>
                <div class="col-sm-8">
                  <input class="form-control" type="text"
                    v-model="searchForm.rego"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Car Number:</label>
                <div class="col-sm-8">
                  <input class="form-control" type="text"
                    v-model="searchForm.number"/>
                </div>
              </div>
              <object-select-input v-if="reservations.objects.length > 0" v-bind:field.sync="reservations"></object-select-input>
              <div v-else class="form-group">
                <label class="col-sm-4 control-label">Current Reservations:</label>
                <div class="col-sm-8 top-padding">
                  No current reservations.
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-4 col-sm-8">
                  <button type="submit" class="btn btn-default pull-right">
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="box" v-show="cars.length > 0">
          <div class="box-header with-border">
            <h1 class="box-title">Report</h1>
          </div>
          <div class="box-body">
            <template v-for="car in cars">
              <div class="row">
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-3 col-sm-4 col-xs-12">
                      <img class="img-thumbnail"
                        v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+
                        ( car.CarType.AmazonImage.objectKey ?
                          car.CarType.AmazonImage.objectKey : 'spacer.gif' ) +
                          '?v=' + new Date().getTime()"/>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12">
                      <h4 class="list-group-item-heading">Car Details</h4>
                      <p><strong>{{ car.CarType.name }}</strong><br/>
                      {{ car.name }} (#{{ car.convadisId }} - {{ car.rego }})
                      <br/>
                      {{ car.Lot.address }}</p>
                    </div>
                    <div class="col-md-5 col-sm-4 col-xs-12">
                      <h4 class="list-group-item-heading">Car Location</h4>
                      <p><strong>Address:</strong> {{ car.Lot.address }}<br/>
                      <strong>Location Details:</strong>
                      {{ car.Lot.addressMemo }}</p>
                      <p><a v-bind:href="'https://www.google.com/maps?q='+
                      car.Lot.latitude +','+ car.Lot.longitude" target="_blank"
                      class="btn btn-default btn-sm">View on Google Maps</a></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <button v-link="{ path: '/report/damage/' + car.uuid }"
                  class="btn btn-default btn-report">Report Damage</button>
                  <button v-link="{ path: '/report/clean/' + car.uuid }"
                  class="btn btn-default btn-report">Request Clean</button>
                  <button v-link="{ path: '/report/lowfuel/' + car.uuid }"
                  class="btn btn-default btn-report">Report Low Fuel</button>
                  <button v-link="{ path: '/report/spacetaken/' + car.uuid }"
                  class="btn btn-default btn-report">Car Space Taken</button>
                  <button v-link="{ path: '/report/car-not-there/' + car.uuid }"
                  class="btn btn-default btn-report">Car Not There</button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectSelectInput from '../inputs/ObjectSelectInput.vue'
export default {
  name: 'Report',
  components: {
    ObjectSelectInput
  },
  data () {
    return {
      reservations: {
        objects: []
      },
      cars: [],
      searchForm: {
        rego: '',
        number: '',
        reservation: ''
      }
    }
  },
  route: {
    data () {
      let authType = this.$route.authType
      if (this.$route.params.carId) {
        let params = this.$route.params
        this.$http.get(`${authType}/report/get-car`, { params })
        .then((response, status, request) => {
          this.cars[0] = response.data.car
        })
      }
      this.$http.get(`${authType}/report/get-reservations`, {})
      .then((response, status, request) => {
        this.reservations = response.data.reservations
      })
    }
  },
  methods: {
    search () {
      if (this.reservations.value) {
        this.searchForm.reservation = this.reservations.value
      }
      if (this.searchForm.rego || this.searchForm.number || this.searchForm.reservation) {
        let authType = this.$route.authType
        this.$http.get(`${authType}/report/search`, { params: this.searchForm })
        .then((response, status, request) => {
          this.cars = response.data.cars
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Report.vue?2ad8ef93